<div class="customer-sumary-root">
  <div class="content" *ngIf="!loading">
    <div class="infos">
      <app-business-basic-details
        class="section-full"
        [businessSummary]="businessSumary"
        [nRepresentative]="nRepresentatives"
        [resellerName] = "resellerName"
        (businessDataChanged)="businessUpdated.emit()"
      ></app-business-basic-details>
    </div>
    <div class="vip-list">
      <app-business-vip-details 
        class="section-full"
        [businessSummary]="businessSumary"
        [nRepresentative]="nRepresentatives"
        [businessVIPCoupons]="businessVIPCoupons"
        [refreshAction]="refreshBusinessData.bind(this)"
        [viewOnly]="viewOnly"
      ></app-business-vip-details>
    </div>
    <div class="representatives">
      <app-representative-invite-list
        [isSummary]="true"
        [businessId]="businessId"
        [businessStatus]="businessSumary.status"
        (nRepresentativeEvent)="representativeCount($event)"
        [isBusinessActive]="businessSumary.active"
      >
      </app-representative-invite-list>
    </div>
  </div>
  <mat-spinner diameter="100" *ngIf="loading"></mat-spinner>
</div>
